import React, {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {MatomoProvider, createInstance} from '@datapunt/matomo-tracker-react';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));
const matomoUrl = window.env.REACT_APP_MATOMO_API;
const matomoDisabled = window.env.REACT_APP_MATOMO_DISABLED === 'true';
const matomoSiteId = parseInt(window.env.REACT_APP_MATOMO_SITE_ID, 10);
const container = document.getElementById('root');
const root = createRoot(container);

const instance = createInstance({
  urlBase: matomoUrl,
  siteId: matomoSiteId,
  disabled: matomoDisabled,
});

/**
 * Top Level Component that implements main app,
 *  redux store and web analytics software
 * @namespace Routing
 */
const Main = () => (
  <MatomoProvider value={instance}>
    <Provider store={store}>
      <Suspense fallback={<div className="loading" />}>
        <App />
      </Suspense>
    </Provider>
  </MatomoProvider>
);

root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
